var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.727 3c.49 0 .92.209 1.214.55l1.557 1.883A2.127 2.127 0 0121 6.818v12.534a1.75 1.75 0 01-1.75 1.75H4.75A1.75 1.75 0 013 19.352V6.818a2.193 2.193 0 01.006-.164c.032-.433.191-.836.444-1.158L5.007 3.6c.306-.37.753-.6 1.266-.6h11.454zM4.5 7.5v11.852c0 .138.112.25.25.25h14.5a.25.25 0 00.25-.25V7.5h-5.25v2a1 1 0 01-1 1h-2.5a1 1 0 01-1-1v-2H4.5zM13.25 6h5.77l-1.213-1.467c-.018-.023-.038-.033-.08-.033H6.273c-.046 0-.075.014-.107.052L4.976 6H13.25zM15 16.75a1 1 0 011-1h1a1 1 0 011 1V17a1 1 0 01-1 1h-1a1 1 0 01-1-1v-.25z"
  })));
}

export default SvgBox;